import AggregateRating from './aggregateRating';
import Branch from './branch';
import removeAccents from 'remove-accents';

export default function ServiceInfo(data){
    let service = data || {};
    this.id = service.id;
    this.name = service.name;
    const normalizedName = removeAccents((service.name || ""));
    this.nameNoAccents = normalizedName.toLowerCase().replace(/\s/gi, "");
    this.description = service.description;
    this.aggregateRating = new AggregateRating(service.aggregateRating);
    this.branches = service.branches !== undefined && service.branches.length > 0 ? service.branches.map(b => new Branch(b)): service.sportsClubs !== undefined && service.sportsClubs.length >0 ? service.sportsClubs.map(b => new Branch(b)) : [];
}